<template>
    <div class="payable_manage_wrap" v-loading="loading">
        <div class="aside-left">
            <ul>
                <li
                    v-for="item in sourceList"
                    :key="item.id"
                    :class="{ active: source_id == item.id }"
                    @click="handleClickTypeTab(item)"
                >
                    <i class="iconfont icon-a-dingdantuikuanyingfu1" v-if="item.source_type === 'order_return'"></i>
                    <i class="iconfont icon-caigouyingfu" v-else-if="item.source_type === 'purchase'"></i>
                    <i class="iconfont icon-yingfukongjian" v-else></i>
                    <span>{{ item.name }}</span>
                </li>
            </ul>
            <div class="aside_left_static">
                <ul>
                    <li
                        v-for="item in statisticsTypeList"
                        :key="item.type"
                        :class="{ active: statisticsTypeActive == item.type }"
                        @click="handleClickStaticTypeTab(item)"
                    >
                        <i class="iconfont icon-a-yingfutongji1"></i>
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="content-right">
            <template v-if="source_type !== ''">
                <PayableList :payable_type="source_type" :source_id="source_id" v-if="source_id" />
            </template>
            <template v-else>
                <payableStatistics />
            </template>
        </div>
    </div>
</template>
<script>
import { PayableSourceList } from "@/api";
import PayableList from "./payable_list.vue";
import payableStatistics from "./payable_statistics.vue";
export default {
    name: "PayableManage",
    components: { PayableList, payableStatistics },
    data() {
        return {
            loading: false,
            source_type: "purchase", // 来源类型
            source_id: "", // 来源id
            sourceList: [], // 应付来源
            statisticsTypeActive: "",
            statisticsTypeList: [{ type: 1, name: "应付统计" }],
        };
    },
    created() {
        this.getPayableSourceList();
    },
    methods: {
        // 应付来源
        getPayableSourceList() {
            PayableSourceList().then((res) => {
                if (res.code === 200) {
                    this.sourceList = res.data || [];
                    if (this.sourceList.length) {
                        const purchase_item = this.sourceList.find(item=> item.source_type == 'purchase')
                        let source_type = ""
                        let source_id = 0
                        if(purchase_item) {
                            source_type = purchase_item.source_type
                            source_id = purchase_item.id
                        } else {
                            source_type = this.sourceList[0].source_type
                            source_id = this.sourceList[0].id
                        }
                        this.source_type = source_type
                        this.source_id = source_id
                    }
                }
            });
        },
        handleClickTypeTab(item) {
            this.source_type = item.source_type;
            this.source_id = item.id;
            this.statisticsTypeActive = "";
        },
        handleClickStaticTypeTab(item) {
            this.statisticsTypeActive = item.type;
            this.source_type = "";
            this.source_id = "";
        },
    },
};
</script>
<style lang="scss" scoped>
.payable_manage_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    .aside-left {
        width: 196px;
        flex-shrink: 0;
        padding: 12px 8px;

        ul {
            li {
                width: 100%;
                padding: 8px;
                display: flex;
                align-items: center;
                gap: 8px;
                cursor: pointer;
                color: rgba(102, 102, 102, 100);
                border-radius: 4px;
                font-weight: 400;

                span {
                    font-size: 14px;
                    letter-spacing: 0px;
                    line-height: 22px;
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
                &.active {
                    background: rgba(41, 144, 255, 0.16);
                    font-weight: 700;
                    color: #2990ff;
                }
            }
        }
        .aside_left_static {
            position: relative;
            margin-top: 8px;
            padding-top: 8px;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 3px;
                right: 3px;
                height: 1px;
                background-color: rgba(232, 232, 232, 1);
            }
        }
    }
    .content-right {
        flex: 1;
        border-left: 1px solid rgba(232, 232, 232, 1);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .el-tabs {
            ::v-deep {
                .el-tabs__nav {
                    margin: 0 16px;
                }
                .el-tabs__header {
                    margin: 0;
                }
                .el-tabs__item {
                    padding: 0 16px !important;
                    height: 48px;
                    line-height: 48px;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                    &.is-active {
                        font-weight: 700;
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
        .content_right_wrap {
            flex: 1;
            padding: 16px;
        }
    }
}
.dialog_label_text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 4px;
}
</style>
